import { StandaloneTopBar } from '@/components/Layout/StandaloneTopBar'

const LAST_UPDATED = '18 June 2026'

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <StandaloneTopBar backTo="/" backLabel="Back to home" />
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
        <p className="text-justify text-muted-foreground text-sm mb-8">Last updated: {LAST_UPDATED}</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/90">
          <Section title="1. Acceptance">
            By accessing or using CONORBIT (conorbit.com), you agree to these Terms.
            If you do not agree, do not use the platform.
          </Section>

          <Section title="2. Services">
            CONORBIT provides a software platform for institutional communications management,
            journalist accreditation, press pass issuance, event management, coverage analytics,
            and association membership management. Services are provided on a subscription basis
            for institutions; the Journalist Portal is free of charge.
          </Section>

          <Section title="3. Accounts">
            You are responsible for maintaining the security of your account credentials.
            Institution accounts must be requested and provisioned by CONORBIT staff.
            Journalist accounts may be self-registered. You must provide accurate information.
          </Section>

          <Section title="4. Acceptable Use">
            You agree not to: (a) submit false information; (b) impersonate another person or
            organisation; (c) attempt to access data belonging to other institutions;
            (d) use the platform for illegal purposes; (e) abuse the fairness engine or
            accreditation system.
          </Section>

          <Section title="5. Content">
            You retain ownership of content you submit (article URLs, profiles, coverage data).
            You grant CONORBIT a licence to display and process that content as required to
            provide the services. You represent that you have the right to submit content.
          </Section>

          <Section title="6. Subscription & Payment">
            Institution subscriptions are billed per the current price list. Payment is due in
            advance. Failure to pay may result in suspension of institution access.
            Journalist Portal access is and will remain free.
          </Section>

          <Section title="7. Association Dues">
            CONORBIT facilitates dues collection on behalf of journalist associations.
            CONORBIT is not responsible for the dues amounts set by associations nor for
            refunds of association dues already collected.
          </Section>

          <Section title="8. Limitation of Liability">
            CONORBIT is provided "as is". To the maximum extent permitted by law, CONORBIT
            limits its liability to the amount you paid in the 3 months prior to any claim.
          </Section>

          <Section title="9. Governing Law">
            These Terms are governed by the laws of Nigeria. Disputes shall be resolved in
            the courts of Lagos State, Nigeria.
          </Section>

          <Section title="10. Contact">
            CONORBIT · hello@conorbit.com · conorbit.com
          </Section>
        </div>
      </div>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="text-[15px] font-semibold mb-2">{title}</h2>
      <div className="text-[13.5px] text-muted-foreground leading-relaxed text-justify">{children}</div>
    </div>
  )
}
